<template>
  <BaseCard>
    <div
      :class="[$style.base, { [$style.smallScreen]: $screen === 's', [$style.mediumScreen]: $screen === 'm' }]"
    >
      <div :class="$style.section">
        <BaseHeading size="s">
          {{ $t('insights.estimated_revenue') }}
        </BaseHeading>
        <BaseHeading
          size="l"
          v-test="'insights-estimated-revenue'"
        >
          {{ filters.currency(revenue) }}
        </BaseHeading>
      </div>
      <div :class="$style.section">
        <BaseHeading size="s">{{ $t('insights.time_booked') }}</BaseHeading>
        <BaseHeading
          size="l"
          v-test="'insights-time-booked'"
        >
          {{ totalScheduledHours }}
          {{ $t('global.items.hour', totalScheduledHours) }}
        </BaseHeading>
      </div>
      <div :class="$style.section">
        <BaseHeading size="s">
          {{ $t('insights.booked_appointments') }}
        </BaseHeading>
        <BaseHeading
          size="l"
          v-test="'insights-booked-appointments'"
        >
          {{ totalAppointments }}
        </BaseHeading>
      </div>
      <div :class="$style.section">
        <BaseHeading size="s">{{ $t('insights.time_available') }}</BaseHeading>
        <BaseHeading
          size="l"
          v-test="'insights-time-available'"
        >
          {{ totalAvailableHours }}
          {{ $t('global.items.hour', totalAvailableHours) }}
        </BaseHeading>
      </div>
    </div>
  </BaseCard>
</template>

<script
  setup
  lang="ts"
>
import { useQuery } from '@vue/apollo-composable';
import { storeToRefs } from 'pinia';
import filters from '@/filters';
import { useLocationsStore } from '@/stores/locations';
import { GET_TOTAL_VENUE_INSIGHTS } from './graphql';

defineProps<{
  totalAppointments: number;
  totalScheduledHours: number;
  totalAvailableHours: number;
}>();

const { locationId, dataScope } = storeToRefs(useLocationsStore());
const startAt = inject<Ref<string>>('startAt')!;
const endAt = inject<Ref<string>>('endAt')!;

const { result, loading } = useQuery(GET_TOTAL_VENUE_INSIGHTS, () => ({
  dataScope: dataScope.value,
  locationId: locationId.value,
  startAt: startAt.value,
  endAt: endAt.value,
}));

const revenue = computed(() => result.value?.totalVenueInsights.total || 0);
</script>

<style
  lang="scss"
  module
>
.base {
  display: flex;
  gap: $spacing;

  &.smallScreen, &.mediumScreen {
    flex-wrap: wrap;
  }
}

.section {
  display: flex;
  flex-direction: column;
  gap: $spacing * 0.5;

  .base:not(.smallScreen):not(.mediumScreen) & {
    &:first-child {
      width: 28%;
    }

    &:not(:first-child) {
      width: 24%;
      padding-left: $spacing;
    }

    &:not(:last-child) {
      padding-right: $spacing;
      border-right: 1px solid var(--color-border);
    }
  }

  .base.mediumScreen & {
    width: calc(50% - $spacing * 0.5);
  }

  .base.smallScreen & {
    width: 100%;
  }
}
</style>
